import { inject, InjectionKey } from 'vue';
import { RosterApiService } from './rosterApiService';

export const ROSTER_API_KEY: InjectionKey<RosterApiService> = Symbol('RosterApiService');

export function useRosterApi(): RosterApiService {
	const service = inject<RosterApiService>(ROSTER_API_KEY);
	if (!service) throw new Error('RosterApiService not provided');
	return service;
}
